<template>
  <div class="hello">
    <div ref="container"></div>
    <!-- 业务接管区 UUID 列表 -->
    <div v-if="freeAreaZones.length > 0" class="free-area-panel">
      <div v-for="zone in freeAreaZones" :key="zone.uuid || zone.id" class="free-area-item">
        <span class="fa-dot" :class="zone.buildTaskStatus === -1 ? 'fa-warn' : 'fa-ok'"></span>
        <span class="fa-uuid">UUID:{{ zone.uuid }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, onBeforeUnmount, computed, render } from 'vue';
import * as THREE from 'three';

import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
import { useStore, useWsModule } from '@/store/index';
import { PerspectiveEnum } from '@/store/types';
import { PlayStateEnum } from '@/store/modules/ws/types';
import { loadVehicle } from '@/utils/modelLoader';
import { render_virtual_obstacle, visible_virtual_obstacle_sign, render_custom_zones, clear_virtual_obstacle, clearFreeAreaModel } from './js/virtual_obstacle';

import {
  renderMap_all,
  setMapVisible,
  setMapVisible_all,
  clearMapGroup,
  filterMapAll,
  renderMap,
} from './js/allmap'; //全图
import { initThreejs } from './js/initThree'; //初始化threejs
import { loadPublicResource } from './js/resourceLoad'; //资源加载
import {
  loadObstacle,
  clearObstacle,
  obstacleLabel_visible,
} from './js/obstacle'; //资源加载
import { getelementSetting } from './js/setting'; //资源加载
import {
  initOrbit,
  setCameraPerspective,
  set_cameraPerspectiveAuto,
  saveOribitChange,
  set_camera_free,
} from './js/orbitControlsHelp'; //资源加载

import { ZCSToWGS84, WGS84ToLocal } from '@/utils/coordinateHelper';
import { getFreeArea } from '@/service';
import { loadFontModel } from '@/utils/vehicleHelper';

// ----------------- 每次事件操作重置一下内存占用 -----------------
import RafHelper from './js/RafHelper.ts';

import { loadVehicleRouting } from './pnc/pnc_routing';
import { load_fused_track_movable_gate } from './fused/fused_track_movable_gate';
import { load_fused_track_traffic_sign } from './fused/fused_track_traffic_sign';
import { loadVehiclePlanning } from './pnc/pnc_planning';
import { render_planning_result } from './pnc/pc_planning_result';
import { useFrameDataStore } from "@/store/frameDataStore";
import { useVisibleChannelStore } from "@/store/visibleChannelStore";
import { visible_topic_localmap, load_topic_localmap, clear_topic_localmap } from "./map/map_view";
import { loadVehicle_shield_output, clear_vehicle_shield_output, vehicle_shield_output_visible } from "./pnc/vehichle_shield_output";
import { loadVehicle_shield_output_emergencysteering_path, clear_vehicle_shield_output_emergencysteering_path, vehicle_shield_output_visible_emergencysteering_path } from "./pnc/vehichle_shield_output_emergencysteering_path";
import { load_pnc_constructionAreasList } from './businessInfo/pnc_constructionAreasList';
import { load_erase_obstacle_areas } from './businessInfo/erase_obstacle_areas';
import { load_gps_pose_trajectory, clear_gps_pose_trajectory, set_gps_trajectory_visible } from './localization/gps_pose_trajectory';
let renderEnabled = false;
const raf = new RafHelper();
let timeOut = null;
const timeRender = (time = 3000) => {
  renderEnabled = true;
  raf.clearTimeout(timeOut);
  timeOut = raf.setTimeout(() => {
    renderEnabled = false;
  }, time);
};
// ----------------------------------------------------------------

let obstacleLabelMap = new Map();
let elementSetting = getelementSetting();
let sceneVehicle = null;
let vehicleShape = null;
let origin = null;//主车map定位
let orientation = null;
let vehicle_orientation = null;

let vehicleParams = {
  width: 1.564, backEdgeToCenter: 0.816, height: 2.1025, length: 3.6335
};
let distanceMesh = null;
let freeAreaMesh = null;

let container = ref(null);
const freeAreaZones = ref([]);

//#region 全局变量
/**
 * ThreeJs的全局对象
 */
let threejs_global = {
  camera: null,//相机
  renderer: null,//渲染器
  controls: null,//控制器
  scene: null,//除地图之外的场景,
  groupMap: null,//
  groupMap_local: null,//
  scene_source: null//主场景
};

let isReloadVechicleModelPositon = true;
let vehicleData_current = null;
let vehicle_box_size = null;
let freeAreaInterval = null;

const store = useStore();
onMounted(async () => {
  //初始化调用
  console.log('初始化页面及Threejs');
  isDebug = localStorage.getItem('debug');
  threejs_global = initThreejs({ container: container.value })
  store.state.wsModule.threejs_global = threejs_global;

  threejs_global.controls.addEventListener('change', (e) => {
  })
  threejs_global.controls.addEventListener('start', (e) => {
    set_cameraPerspectiveAuto(false, threejs_global.camera)
  })
  threejs_global.controls.addEventListener('end', (e) => {
    if (
      store.state.perspective.type === PerspectiveEnum.free &&
      store.state.mode != 'connection'
    ) {
      if (!origin) {
        return;
      }
      let x_cha = Math.abs(threejs_global.controls.target.x - origin.x);
      let y_cha = Math.abs(threejs_global.controls.target.y - origin.y);
      if (x_cha < 100 && y_cha < 100) {
        return;
      }
      if (isSliceMap()) {
        loadSliceMap(threejs_global.controls.target).then(data => {
          renderMap_all(
            data,
            { x: threejs_global.controls.target.x, y: threejs_global.controls.target.y, z: origin.z },
            threejs_global.groupMap,
            mapLabelMap,
            getMapLabelVisible(),
            elementSetting
          )
        })
      } else {
        filter_map_all_move = filterMapAll(
          store.state.wsModule.allMapData,
          threejs_global.controls.target
        )
        renderMap_all(
          filter_map_all_move,
          { x: threejs_global.controls.target.x, y: threejs_global.controls.target.y, z: origin.z },
          threejs_global.groupMap,
          mapLabelMap,
          getMapLabelVisible(),
          elementSetting
        )
      }
    }
    if (store.state.perspective.type != PerspectiveEnum.free) {
      saveOribitChange(threejs_global.controls, vehicle_orientation)
      set_cameraPerspectiveAuto(true, threejs_global.camera)
    }

  })

  loadPublicResource()
  //预加载主车模型
  loadVehicleModel(() => { })
  threejs_global.eventRender.funcArr.push(() => {
  })
});

const fetchAndRenderFreeArea = async () => {
  if (frameDataStore.progress_status === 1) {
    return;
  }

  const localization = vehicleData_current?.localization;
  if (!localization) return;

  let x, y, meta;

  if (localization.mapMode === 1) {
    // 采图模式：使用 gpsPosePosition，meta 取自 localization.mapVersionMeta
    const gpsPose = localization.gpsPosePosition;
    if (!gpsPose?.x || gpsPose.x === '0' || !gpsPose?.y || gpsPose.y === '0') {
      return;
    }
    x = gpsPose.x;
    y = gpsPose.y;
    meta = localization.mapVersionMeta;
  } else {
    // 正常模式：使用 globalPosition，meta 取自 store.state.mapVersionMeta
    const globalPos = localization.globalPosition;
    if (!globalPos?.x || globalPos.x === '0' || !globalPos?.y || globalPos.y === '0') {
      return;
    }
    x = globalPos.x;
    y = globalPos.y;
    meta = store.state.mapVersionMeta;
  }

  try {
    const { lon, lat } = ZCSToWGS84(x, y);
    const res = await getFreeArea({ lon, lat });

    if (!res || !res.success) {
      clearFreeAreaModel();
      freeAreaZones.value = [];
      return;
    }

    const rawData = res.data;
    if (!Array.isArray(rawData) || rawData.length === 0) {
      clearFreeAreaModel();
      freeAreaZones.value = [];
      return;
    }

    if (!meta?.utmZone) {
      console.warn('Map version data not available yet');
      return;
    }

    const { utmZone, offsetX, offsetY } = meta;
    const zones = rawData
      .filter(item => item.freeArea?.wgs84s && item.freeArea.wgs84s.length > 0)
      .map(item => ({
        id: item.freeArea.id,
        uuid: item.freeArea.uuid,
        points: item.freeArea.wgs84s.map(p => WGS84ToLocal(p.lon, p.lat, offsetX, offsetY, utmZone)),
        buildTaskStatus: item.buildTaskStatus
      }));

    if (zones.length === 0) {
      clearFreeAreaModel();
      freeAreaZones.value = [];
      return;
    }

    freeAreaZones.value = zones;
    render_custom_zones(zones, threejs_global.scene);

  } catch (e) {
    console.error("Failed to fetch or draw free area", e);
    clearFreeAreaModel();
    freeAreaZones.value = [];
  }
};

const startFreeAreaPolling = (interval = 5000) => {
  if (freeAreaInterval) {
    clearInterval(freeAreaInterval);
  }
  freeAreaInterval = setInterval(fetchAndRenderFreeArea, interval);
};

const stopFreeAreaPolling = () => {
  if (freeAreaInterval) {
    clearInterval(freeAreaInterval);
    freeAreaInterval = null;
  }
};
//#region 根据数据增量渲染/

/**
 * 渲染主车数据
 */
let config_CommonListChecks = ref(localStorage.getItem('config_CommonListChecks'));
const renderVehicle = (vehicleData, renderVhicleLineGroup = true) => {
  vehicleData_current = vehicleData;
  if (!sceneVehicle) {
    //第一次加载
    //主车场景
    sceneVehicle = new THREE.Scene();
    sceneVehicle.background = new THREE.Color(0xffffff);
    sceneVehicle.environment = threejs_global.pmremGenerator.fromScene(new RoomEnvironment()).texture
    sceneVehicle.position.set(0, 0, 0)
    threejs_global.scene.add(sceneVehicle)

    //加载主车模型
    loadVehicleModel((model) => {
      if (!vechicleModel) {
        let center = {
          x: vehicleParams.length / 2 - vehicleParams.backEdgeToCenter,
          y: 0,
          z: 0.023,
        };

        model.position.set(center.x, center.y, center.z);
        model.rotation.set(Math.PI / 2, -Math.PI, 0.05);

        vechicleModel = new THREE.Group();
        vechicleModel.add(model);
        vechicleModel.position.set(0, 0, 0);
        sceneVehicle.add(vechicleModel);
        vechicleModel.visible = config_CommonListChecks.value ? config_CommonListChecks.value.includes('vehicle_3d_visible') : true; // 控制主车模型显示隐藏
        setVehicle(vehicleData);
      }
    });
    loadSceneVehicleOrigin(vehicleData);
  }
  if (
    isReloadVechicleModelPositon &&
    vechicleModel &&
    vechicleModel.children.length > 0
  ) {
    let center = {
      x: vehicleParams.length / 2 - vehicleParams.backEdgeToCenter,
      y: 0,
      z: 0.023,
    };
    vechicleModel.children[0].position.set(center.x, center.y, center.z);
    isReloadVechicleModelPositon = false;
  }

  // loadVehicleLine(vehicleData);

  //
  //跟随数据要变换的配置
  //1,相机、控制器、主车场景定位
  setCameraPerspective(vehicleData, threejs_global.controls, threejs_global.camera, store.state.perspective.type, threejs_global.scene)
  sceneVehicle.position.set(vehicleData.origin.x, vehicleData.origin.y, 0.023);
  if (vechicleModel) {
    setVehicle(vehicleData);
  }
  loadVehicleShape(vehicleData);
  loadVehiclePlanning(vehicleData, threejs_global, vehicleParams);
  render_planning_result(vehicleData, threejs_global.scene, vehicleData.origin, vehicleParams)
  loadVehicleRouting(vehicleData, threejs_global, vehicleParams);
  load_fused_track_movable_gate(vehicleData, threejs_global.scene)
  load_fused_track_traffic_sign(vehicleData, threejs_global.scene)
  load_pnc_constructionAreasList(vehicleData, threejs_global.scene)
  load_erase_obstacle_areas(vehicleData, threejs_global.scene)
  Promise.resolve().then(() => {
    loadObstacle(
      vehicleData,
      threejs_global.scene,
      obstacleLabelMap,
      rotaZCamera,
      elementSetting,
    );
  });
  render_virtual_obstacle(vehicleData, threejs_global.scene);
  loadVehicle_shield_output(vehicleData, threejs_global.scene, vehicleParams)
  loadVehicle_shield_output_emergencysteering_path(vehicleData, threejs_global.scene, vehicleParams)
  // 传入当前时间戳用于检测时间跳转
  const currentTimestamp = frameDataStore.currentTime;
  load_gps_pose_trajectory(vehicleData, threejs_global.scene, currentTimestamp);
  // setVehicleScene_shadow(vehicleData);
};


//#endregion
//#region 主车相关
/**
 * 加载车轴中心
 */
const loadSceneVehicleOrigin = (vehicleData) => {
  const geometry = new THREE.SphereGeometry(0.1, 32, 16);
  const material = new THREE.MeshBasicMaterial({
    color: 0x00ff00,
    side: THREE.DoubleSide,
    depthTest: false,
  });
  let circle2 = new THREE.Mesh(geometry, material);
  circle2.position.set(0, 0, 0);
  sceneVehicle.add(circle2);
};
/**
 * 加载主车模型的promise
 */
let promise_vechicleModel = null;
/**
 * 主车的3D模型;
 */
let vechicleModel = null;

/**
 * 加载主车3D模型
 */
const loadVehicleModel = (callback) => {
  if (vechicleModel) {
    //主车模型已加载
    Promise.resolve().then(() => {
      callback(vechicleModel.children[0]);
    });
  } else {
    //加载模型
    if (promise_vechicleModel) {
      //已经启动，加载中...
      promise_vechicleModel.then((model) => {
        callback(model);
      });
    } else {
      //未启动加载;开始启动加载
      promise_vechicleModel = loadVehicle('zhuche1.glb');
      promise_vechicleModel.then((model) => {
        callback(model);
      });
    }
  }
};
/**
 * 设置主车位置 角度等
 */
const setVehicle = (vehicleData) => {
  vechicleModel.rotation.set(
    vehicleData.vehicle.orientation.x,
    vehicleData.vehicle.orientation.y,
    vehicleData.vehicle.orientation.z,
    'ZYX',
  );
};

/**
 * 主车占位立方体加载
 */
const loadVehicleShape = (vehicleData) => {
  if (!vehicleShape) {
    let { length, height, width } = vehicleParams;
    const geometry = new THREE.BoxGeometry(length, width, height);
    const edges = new THREE.EdgesGeometry(geometry);
    const line = new THREE.LineSegments(
      edges,
      new THREE.LineBasicMaterial({ color: 0x00ff00 }),
    );
    let center = {
      x: vehicleParams.length / 2 - vehicleParams.backEdgeToCenter,
      y: 0,
      z: height / 2 + 0.023,
    };
    line.position.set(center.x, center.y, center.z);
    vehicleShape = new THREE.Group();
    vehicleShape.add(line);
    vehicleShape.position.set(0, 0, 0);
    sceneVehicle.add(vehicleShape);
  }
  vehicleShape.rotation.set(
    vehicleData.vehicle.orientation.x,
    vehicleData.vehicle.orientation.y,
    vehicleData.vehicle.orientation.z,
    'ZYX',
  );
};


//#endregion

//#region 方法 地图
let mapLabelMap = new Map();

const disposeO3D = (object3D) => {
  // debugger
  if (!object3D) return;
  if (object3D.children && object3D.children.length > 0) {
    object3D.children.forEach((e) => {
      disposeO3D(e);
    });
  }
  if (object3D.parent) object3D.parent.remove(object3D); //.removeFromParent()
  if (object3D.geometry && object3D.geometry.dispose) {
    object3D.geometry.dispose();
  }
  if (object3D.dispose) {
    object3D.dispose();
  }
  if (object3D.clear) {
    object3D.clear();
  }
};

//#endregion

//#region  监控事件
/**
 * 监听总数据变化
 * 只要传过来的数据发生变化了的回调
 * 写在watch里面即可
 * e就是总数据
 */
const allData = useWsModule((wsModule) => {
  if (!wsModule.data.timestamp) {
    return {};
  }
  return wsModule.data;
});

/**
 *第一次加载数据 *
 */
let isFirstLoad = true;
let rotaZCamera = null;
let filter_map_all_move = null;
let renderInterval;

watch(
  computed(() => [
    store.state.wsModule.playbackState,
    store.state.wsModule.speed,
  ]),
  ([state, speed]) => {
    let intervalMs;
    if (renderInterval) {
      clearInterval(renderInterval);
    }
    if (state === 0) {
      if (speed <= 1) {
        intervalMs = 60;
      } else if (speed === 2) {
        intervalMs = 40;
      } else if (speed === 3) {
        intervalMs = 20;
      }
      // renderInterval = setInterval(render_interval, intervalMs, intervalMs);
    }
  },
);

watch(
  computed(() => store.state.wsModule.prevFlag),
  () => {
  },
);

watch(
  computed(() => store.state.wsModule.nextFlag),
  () => {
  },
);



//#endregion

//#region 数据更新


const vehicleInfo = useWsModule((wsModule) => wsModule.vehicleInfo);

/**
 * 监控metaData数据；
 */
watch(vehicleInfo.data, (e) => {
  if (e && e?.vehicleParam && e?.vehicleParam?.height) {
    let { length, height, width } = e?.vehicleParam;
    vehicle_box_size = { length, height, width };
    loadVehicleModel((model) => {
      model.scale.set(
        length / model.size.x,
        height / model.size.y,
        width / model.size.z,
      );
    });
    vehicleParams = e.vehicleParam;
    vehicleParams.vehicleHeight = e.vehicleParam.height;
  }
}, {
  deep: true,
  immediate: true
});

//#endregion

//#region  视角代码---

watch(
  computed(() => store.state.perspective),
  (e) => {
    set_cameraPerspectiveAuto(
      store.state.perspective.type != PerspectiveEnum.free,
      threejs_global.camera
    )
    initOrbit(store.state.perspective.type)
    if (!origin) {
      return
    }
    if (store.state.perspective.type === PerspectiveEnum.free) {
      let rotaZ = 1.5 * Math.PI - orientation.z
      let x = 2 * Math.sin(rotaZ)
      let y = 2 * Math.cos(rotaZ)
      threejs_global.camera.position.set(origin.x, origin.y - 2, threejs_global.scene.position.z + 70)
      threejs_global.controls.enablePan = true
      threejs_global.controls.enableRotate = false
      threejs_global.controls.mouseButtons = {
        LEFT: THREE.MOUSE.PAN,
        MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.PAN
      }
    } else {
      threejs_global.controls.enablePan = false
      threejs_global.controls.enableRotate = true
      threejs_global.controls.mouseButtons = {
        LEFT: THREE.MOUSE.ROTATE,
        MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.PAN
      }
      threejs_global.controls.target.set(origin.x, origin.y, threejs_global.scene.position.z)
      if (vehicleData_current) {
        setCameraPerspective(
          vehicleData_current,
          threejs_global.controls,
          threejs_global.camera,
          store.state.perspective.type,
          threejs_global.scene
        )
      }
    }
  }
)
//#endregion // 视角代码---

//#region 测距代码----
const mouse = new THREE.Vector2();
const raycaster = new THREE.Raycaster();
let lineMaterial = new THREE.LineBasicMaterial({
  color: 'red',
});
const fn = {
  // 所有点 线
  all: [],
  // 俩点一线
  pointsArray: [],
  createPoint: (pos, config = { size: 0.2 }) => {
    let mat = new THREE.MeshBasicMaterial({
      color: 0xff0000,
    });
    let sphereGeometry = new THREE.SphereGeometry(config.size || 0.3, 10, 10);
    let sphere = new THREE.Mesh(sphereGeometry, mat);
    sphere.position.set(pos.x, pos.y, pos.z);
    fn.add(sphere);
  },
  createLine: (points) => {
    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    const line = new THREE.Line(geometry, lineMaterial);
    line.computeLineDistances();
    fn.createLabel(points);
    fn.add(line);
  },
  createLabel(pointsArray) {
    var pos1 = new THREE.Vector3(...pointsArray[0]);
    var pos2 = new THREE.Vector3(...pointsArray[1]);
    const distance = pos1.distanceTo(pos2).toFixed(2);
    let x = (pointsArray[0].x + pointsArray[1].x) / 2 + 2,
      y = (pointsArray[0].y + pointsArray[1].y) / 2,
      z = (pointsArray[0].z + pointsArray[1].z) / 2;

    loadFontModel(distance + `m`, 1, (mesh) => {
      mesh.position.set(x, y, 0);
      mesh.rotation.z = 210;
      fn.add(mesh);
    });
  },
  createMoveLine(point) {
    var lineGeometry = new THREE.BufferGeometry();
    var lineMaterial = new THREE.LineBasicMaterial({ color: 0xff0000 });
    if (fn.pointsArray.length > 0) {
      const pointArr = [...fn.pointsArray[0], point.x, point.y, point.z];
      lineGeometry.setAttribute(
        'position',
        new THREE.Float32BufferAttribute(pointArr, 3),
      );
      var line = new THREE.Line(lineGeometry, lineMaterial);
      line.name = 'line_move';
      fn.add(line);

      var pos1 = new THREE.Vector3(...fn.pointsArray[0]);
      var pos2 = new THREE.Vector3(...point);
      const distance = pos1.distanceTo(pos2).toFixed(2);
      let x = (fn.pointsArray[0].x + point.x) / 2 + 2,
        y = (fn.pointsArray[0].y + point.y) / 2;
      loadFontModel(distance + `m`, 1, (mesh) => {
        threejs_global.scene.remove(
          threejs_global.scene.getObjectByName('moveText'),
        );
        mesh.position.set(x, y, 0);
        mesh.rotation.z = 210;
        mesh.name = 'moveText';
        fn.add(mesh);
      });
    }
  },
  add(item) {
    fn.all.push(item);
    threejs_global.scene.add(item);
  },
  clear() {
    threejs_global.scene.remove(...fn.all);
    fn.all.forEach((item) => disposeO3D(item));
    fn.all = [];
    fn.pointsArray = [];
    mouseState = false;
  },
};
watch(
  computed(() => store.state.wsModule.listIndex),
  () => {
    store.commit('changeDistanceMeasurement', {
      status: false,
    });
  },
);

watch(
  computed(() => store.state.distanceMeasurement.status),
  (e) => {
    if (e) {
      document.body.style.cursor = 'url(./images/ruler.png), pointer';
    } else {
      document.body.style.cursor = 'default';
    }
    fn.clear();
  },
);

let mouseState = false;
let mouseRightState = 0;
const getPoints = (event) => {
  // 通过鼠标点击位置,计算出 raycaster 所需点的位置,以屏幕为中心点,范围 -1 到 1
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  // 通过鼠标点击的位置(二维坐标)和当前相机的矩阵计算出射线位置
  raycaster.setFromCamera(mouse, threejs_global.camera);
  // 获取与射线相交的对象数组，其中的元素按照距离排序，越近的越靠前
  const intersects = raycaster.intersectObjects(threejs_global.scene.children);
  /* // 点击换色


  if(intersects.length > 0){
    const currentModel = intersects[0].object
    currentModel.currentHex = currentModel.material.color.getHex()
    currentModel.material.color.set(0x66ff00)
  } */

  let point;
  intersects.forEach((item) => {
    if (item.object.name === 'groundPlane') {
      point = item.point;
    }
  });
  if (point) {
    point.z = 0;
    return point;
  }
};
let mouseTimer = 0;
const onMouseDown = (event) => {
  if (!store.state.distanceMeasurement.status) {
    return;
  }
  mouseTimer = new Date().getTime();
  timeRender();
};
const onMouseUp = (event) => {
  if (!store.state.distanceMeasurement.status) {
    return;
  }
  if (event.button === 0) {
    mouseRightState = 0;
    mouseTimer = new Date().getTime() - mouseTimer;
    if (mouseTimer > 500) {
      mouseRightState = 1;
      return;
    }
    if (!mouseState) {
      container.value.addEventListener('mousemove', onMouseMove, false);
      /* 依据 windwo_mouse 标识避免事件的重复添加 */
      mouseState = true;
    }

    let point = getPoints(event);
    fn.pointsArray.push(point);
    fn.createPoint(point);
    if (fn.pointsArray.length >= 2) {
      fn.createLine(fn.pointsArray);
      fn.pointsArray.shift();
    }
  } else if (event.button === 2) {
    if (fn.pointsArray.length > 0 && mouseRightState === 0) {
      container.value.removeEventListener('mousemove', onMouseMove, false);
      mouseState = false;
      fn.pointsArray = [];
      mouseRightState = 1;
      threejs_global.scene.remove(
        threejs_global.scene.getObjectByName('moveText'),
      );
    } else if (fn.pointsArray.length === 0 && mouseRightState === 1) {
      fn.clear();
      mouseRightState = 2;
    } else if (mouseRightState === 2) {
      store.commit('changeDistanceMeasurement', {
        status: false,
      });
    }

    /* 鼠标左键未点击时线段的移动状态 */
    if (threejs_global.scene.getObjectByName('line_move')) {
      threejs_global.scene.remove(
        threejs_global.scene.getObjectByName('line_move'),
      );
      /* 删除数组中的元素，否则的话再次重绘会链接之前的点接着重绘 */
      fn.pointsArray.shift();
    }
  }
  timeRender();
};
const onMouseMove = (event) => {
  if (!store.state.distanceMeasurement.status) {
    return;
  }
  /* 鼠标左键未点击时线段的移动状态 */
  if (threejs_global.scene.getObjectByName('line_move')) {
    threejs_global.scene.remove(
      threejs_global.scene.getObjectByName('line_move'),
    );
  }

  let point = getPoints(event);
  fn.createMoveLine(point);
  timeRender();
};
const mouseclick = (event) => {
  let point = getPoints(event);
  if (point) {
    const oX = document.getElementById('x-zhou');
    const oY = document.getElementById('y-zhou');
    if (oX) oX.innerText = point.x;
    if (oY) oY.innerText = point.y;
  }
  timeRender();
};

onMounted(() => {
  container.value.addEventListener('mouseup', onMouseUp, false);
  // window.addEventListener('mouseup', onMouseUpSelectPoint, false)
  // window.addEventListener('mousedown', onMousedownSelectPoint, false)
  container.value.addEventListener('mousedown', onMouseDown, false);
  container.value.addEventListener('click', mouseclick, false);
});

onBeforeUnmount(() => {
  stopFreeAreaPolling();
  clearFreeAreaModel();
  clear_virtual_obstacle();
  document.body.style.cursor = 'default';
  fn.clear();
  container.value.removeEventListener('mouseup', onMouseUp, false);
  container.value.removeEventListener('mousedown', onMouseUp, false);
  // 清理GPS轨迹资源
  clear_gps_pose_trajectory();
});

/**
 * 添加测距地面
 */
const addMesh = (vehicleData) => {
  //测距地面
  if (!distanceMesh) {
    const geometry = new THREE.BoxGeometry(40000, 40000, 0.01);
    const material = new THREE.MeshBasicMaterial({
      color: 0x000000,
      opacity: 0,
    });
    const mesh = new THREE.Mesh(geometry, material);
    mesh.name = 'groundPlane';
    mesh.position.set(vehicleData.origin.x, vehicleData.origin.y, -0.1);
    mesh.renderOrder = -100;
    distanceMesh = mesh;
    threejs_global.scene.add(mesh);
  } else {
    distanceMesh.position.set(vehicleData.origin.x, vehicleData.origin.y, -0.1);
  }
};

//#endregion 测距代码----

//#region 选点
// watch(
//   computed(() => store.state.distanceMeasurement.status),
//   (e) => {}
// )
//选点
let isSelectpoint = false;
const isSelectpoint_store = useWsModule((wsModule) => wsModule.isSelectpoint);
/**
 * 监控metaData数据；
 */
watch(isSelectpoint_store.data, (e) => {
  isSelectpoint = e;
  threejs_global.controls.enablePan = false;
  threejs_global.controls.enableRotate = !isSelectpoint;
  threejs_global.controls.mouseButtons = {
    LEFT: THREE.MOUSE.ROTATE,
    MIDDLE: THREE.MOUSE.DOLLY,
    RIGHT: THREE.MOUSE.PAN,
  };
  if (e) {
    // document.body.style.cursor = 'url(./images/ruler_xd.png), pointer'
    document.body.style.cursor = 'crosshair';
  } else {
    document.body.style.cursor = 'default';
  }
  // fn.clear()
});
let material_xuandian = null;
let group_xuandian = null;
let point_start = null;
let material_xuandian_line = null;
let positions_xuandian = null;
let line_rotation = null;
let arr_point_ele = [];
onMounted(() => {
  container.value.addEventListener('mouseup', onMouseUpSelectPoint, false);
  container.value.addEventListener('mousedown', onMousedownSelectPoint, false);
});
const onMousedownSelectPoint = (event) => {
  event.stopPropagation();
  if (isSelectpoint) {
    if (event.button == 2) {
      //右键取消：
      //  store.dispatch('wsModule/WS_SendPoint', point_start)
      store.commit('wsModule/setSelectpoint', false);
      return;
    }

    point_start = getPoints(event);
    if (!point_start) return;
    container.value.addEventListener(
      'mousemove',
      onMouseMoveSelectPoint,
      false,
    );
    if (arr_point_ele.length > 1) {
      let ele = arr_point_ele.shift();
      disposeO3D(ele.line);
      disposeO3D(ele.point);
    }
    const geometry = new THREE.ConeGeometry(0.2, 1, 32);
    const material = material_xuandian
      ? material_xuandian
      : new THREE.MeshBasicMaterial({ color: 0xffff00 });
    material.opacity = 1;
    material.transparent = true;
    const cone = new THREE.Mesh(geometry, material);

    cone.up = new THREE.Vector3(0, 0, 1);
    cone.rotation.set(Math.PI / 2, 0, Math.PI);
    cone.position.set(point_start.x, point_start.y, 0.5);
    if (!group_xuandian) {
      group_xuandian = new THREE.Group();
      threejs_global.scene.add(group_xuandian);
    }
    let ele_p = {
      point: cone,
    };
    group_xuandian.add(cone);
    //线
    {
      const geometry = new THREE.BufferGeometry();
      positions_xuandian = new Float32Array(6);
      positions_xuandian[0] = point_start.x;
      positions_xuandian[1] = point_start.y;
      positions_xuandian[2] = point_start.z;
      positions_xuandian[3] = point_start.x;
      positions_xuandian[4] = point_start.y;
      positions_xuandian[5] = point_start.z;
      geometry.setAttribute(
        'position',
        new THREE.BufferAttribute(positions_xuandian, 3),
      );
      geometry.setDrawRange(0, 2);
      if (!material_xuandian_line) {
        material_xuandian_line = new THREE.LineBasicMaterial({
          color: 0xf47920,
        });
      }
      const line = new THREE.Line(geometry, material_xuandian_line);
      line.geometry.attributes.position.needsUpdate = true;
      if (!group_xuandian) {
        group_xuandian = new THREE.Group();
        threejs_global.scene.add(group_xuandian);
      }
      group_xuandian.add(line);
      ele_p = {
        point: cone,
        line,
      };
      line_rotation = line;
      arr_point_ele.push(ele_p);
    }
  }
  timeRender();
};
const onMouseMoveSelectPoint = (event) => {
  if (isSelectpoint) {
    if (positions_xuandian) {
      let pointEnd = getPoints(event);
      line_rotation.geometry.attributes.position.array[3] = pointEnd.x;
      line_rotation.geometry.attributes.position.array[4] = pointEnd.y;
      line_rotation.geometry.attributes.position.array[5] = pointEnd.z;
      line_rotation.geometry.attributes.position.needsUpdate = true;
    }
  }
  timeRender();
};
const onMouseUpSelectPoint = (event) => {
  container.value.removeEventListener(
    'mousemove',
    onMouseMoveSelectPoint,
    false,
  );
  if (isSelectpoint && point_start) {
    point_start.heading = Math.atan2(
      positions_xuandian[4] - positions_xuandian[1],
      positions_xuandian[3] - positions_xuandian[0],
    );
    store.dispatch('wsModule/WS_SendPoint', point_start);
  }
  timeRender();
};

//#region varsion2
let isDebug = localStorage.getItem('debug');
let frameDataStore = useFrameDataStore();
const visibleChannelStore = useVisibleChannelStore()

function isInvalidGlobalPosition(globalPosition) {
  if (!globalPosition) return true;
  const x = globalPosition.x;
  const y = globalPosition.y;
  return (
    x == null ||
    x === '' ||
    x === '0' ||
    x === 0 ||
    y == null ||
    y === '' ||
    y === '0' ||
    y === 0
  );
}

function getGpsPoseCoords(gpsPose) {
  if (!gpsPose) return null;
  const x =
    gpsPose.x ?? (gpsPose.xInt != null ? gpsPose.xInt / 1000 : null);
  const y =
    gpsPose.y ?? (gpsPose.yInt != null ? gpsPose.yInt / 1000 : null);
  const z =
    gpsPose.z ?? (gpsPose.zInt != null ? gpsPose.zInt / 1000 : null);
  if (x == null || y == null) return null;
  return { x, y, z: z ?? 0 };
}

/**
 * 解析主车地图坐标：globalPosition 失效时回退到 gpsPose，避免 origin 与停靠点坐标系错位。
 */
function resolveVehicleOrigin(vehicleData) {
  const localization = vehicleData?.localization;
  let origin = { ...vehicleData.origin };

  if (localization?.mapMode === 1) {
    const gpsPose = localization?.gpsPosePosition;
    const meta = localization?.mapVersionMeta;
    if (
      gpsPose?.x && gpsPose.x !== '0' &&
      gpsPose?.y && gpsPose.y !== '0' &&
      meta?.utmZone
    ) {
      const { lon, lat } = ZCSToWGS84(gpsPose.x, gpsPose.y);
      const localPos = WGS84ToLocal(lon, lat, meta.offsetX, meta.offsetY, meta.utmZone);
      origin = { ...origin, x: localPos.x, y: localPos.y };
    }
    return origin;
  }

  const gpsCoords = getGpsPoseCoords(localization?.gpsPose);
  if (gpsCoords && isInvalidGlobalPosition(localization?.globalPosition)) {
    origin = { ...origin, ...gpsCoords };
  }

  return origin;
}

watch(() => frameDataStore.currentData, (e) => {
  try {
    if (isDebug) {
      console.log('帧数据', e);
    }
    if (!e) return
    if (e?.vehicleData) {
      threejs_global.scene.position.set(0, 0, 0);
      origin = resolveVehicleOrigin(e.vehicleData);
      e.vehicleData.origin = origin;
      orientation = e.vehicleData.vehicle.orientation
      vehicle_orientation = e.vehicleData.vehicle.orientation
      if (isFirstLoad) {
        if (e.mapData) {
          // store.state.wsModule.allMapData_sub.firstMap = e.mapData;
        }
        console.log('主车信息', e.vehicleData)
        isFirstLoad = false
        addMesh(e.vehicleData)
        initOrbit(store.state.perspective.type)
        set_camera_free(e.vehicleData, threejs_global.controls, threejs_global.camera, store.state.perspective.type, threejs_global.scene)
      }
      renderVehicle(e.vehicleData);

    }
    visible_virtual_obstacle_sign(visibleChannelStore.config_CommonListChecks.flat().includes('obstacle_visible'))
    if (visibleChannelStore.showChannelMap.globalMap) {
      threejs_global.groupMap.visible = true;
      renderMap_all(
        e.mapData,
        origin,
        threejs_global.groupMap,
        mapLabelMap,
        getMapLabelVisible(),
        elementSetting
      )
    } else {
      threejs_global.groupMap.visible = false;
    }
    if (visibleChannelStore.showChannelMap.localMap) {
      threejs_global.groupMap_local.visible = true;
      load_topic_localmap(
        e.vehicleData?.localMap,
        threejs_global.groupMap_local,
        elementSetting
      )
    } else {
      threejs_global.groupMap_local.visible = false;
    }
  } catch (ex) {
    console.log(ex)
  }
})
watch(() => frameDataStore.currentData_map, (data_map) => {
  try {
    if (!data_map) return
    if (visibleChannelStore.showChannelMap.globalMap) {
      threejs_global.groupMap.visible = true;
      store.commit('setMapVersionMeta', data_map.mapData.mapVersionMeta)
      renderMap_all(
        data_map.mapData,
        origin,
        threejs_global.groupMap,
        mapLabelMap,
        getMapLabelVisible(),
        elementSetting
      )
    } else {
      threejs_global.groupMap.visible = false;
    }
  } catch (ex) {
    console.log(ex)
  }
})


function getMapLabelVisible(params) {
  return store.state.mapLabelVisible == "1" ? true : false;
}

watch(() => visibleChannelStore.showChannelMap, (e) => {
  setMapVisible_all(e.globalMap)
  elementSetting.mapSetting["lane_virtual"].visible = visibleChannelStore.showChannelMap.virtualLane
  elementSetting.mapSetting["lane_road_mocked"].visible = visibleChannelStore.showChannelMap.virtualLane
  elementSetting.mapSetting['cross_walk'].visible = visibleChannelStore.showChannelMap.crossWalk;
  if (elementSetting.mapSetting["lane_virtual"].group) {
    elementSetting.mapSetting["lane_virtual"].group.visible = visibleChannelStore.showChannelMap.virtualLane
  }
  if (elementSetting.mapSetting["lane_road_mocked"].group) {
    elementSetting.mapSetting["lane_road_mocked"].group.visible = visibleChannelStore.showChannelMap.virtualLane
  }
  if (elementSetting.mapSetting['cross_walk'].group) {
    elementSetting.mapSetting['cross_walk'].group.visible = visibleChannelStore.showChannelMap.crossWalk;
  }
  obstacleLabel_visible(visibleChannelStore.showChannelMap.obstaclLabelStatic, visibleChannelStore.showChannelMap.ganzhiChecks);
  
  // GPS轨迹线显示控制
  set_gps_trajectory_visible(e.gpsTrajectory);

  // 业务接管区轮询控制
  if (e.freeArea) {
    startFreeAreaPolling();
  } else {
    stopFreeAreaPolling();
    clearFreeAreaModel();
    freeAreaZones.value = [];
  }

}, {
  deep: true,
  immediate: true
})
watch(() => visibleChannelStore.config_CommonListChecks, (e) => {
  if (vechicleModel) {
    vechicleModel.visible = e.flat().includes('vehicle_3d_visible');
  }
}, {
  deep: true,
  immediate: true,
})
//#endregion
</script>
<style scoped>
.hello {
  position: relative;
  width: 100%;
  height: 100%;
}

.title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  color: rgb(255, 255, 255);
}

#instructions {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}

.free-area-panel {
  position: absolute;
  top: 20px;
  right: 8px;
  z-index: 1001;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 4px 8px;
  max-height: 40vh;
  overflow-y: auto;
  font-size: 11px;
  line-height: 1.5;
  pointer-events: auto;
}

.free-area-title {
  color: #57fffe;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 2px;
}

.free-area-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 1px 0;
}

.fa-dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 5px;
}

.fa-ok { background: #18c918; }
.fa-warn { background: #f0a500; }

.fa-uuid {
  color: #fff;
}
</style>
